import { TWidgetPlan } from '@entities/widget-shop/model/types';
// TODO снести в будущем, плохая практика

export type YandexEventArgsMap = {
    tasks: {
        filterSearch: {
            filterValue: string;
            actionData: string;
        };
        filterColor: {
            filterValue: string;
            actionData: string;
        };
        filterTags: {
            filterValue: string;
            actionData: string;
        };
        filterObjectsOrEstimates: {
            filterValue: string;
            actionData: string;
        };
        filterExecutor: {
            filterValue: string;
            actionData: string;
        };
        filterTypes: {
            filterValue: string;
            actionData: string;
        };
    };
    eventJournal: {
        tab: {
            actionData: string;
        };
    };
    widgets: {
        tab: string;
        viewFullDescription: {
            widgetTitle: string;
            activeCompanyTariff: string;
        };
        connect: {
            widgetTitle: string;
            activeCompanyTariff: string;
            isFree: boolean;
        };
        purchase: {
            widgetTitle: string;
            activeCompanyTariff: string;
            paymentType: string;
            widgetPlan: TWidgetPlan;
            isRecurrent: boolean;
        };
        prolong: {
            widgetTitle: string;
            activeCompanyTariff: string;
        };
    };
};

export type YandexEventCategory = keyof YandexEventArgsMap;

export type YandexEventName<C extends YandexEventCategory> = keyof YandexEventArgsMap[C];

export type YandexEventArgs<
    C extends YandexEventCategory,
    N extends YandexEventName<C>
> = YandexEventArgsMap[C][N];

export const YANDEX_EVENT_NAMES: {
    [C in YandexEventCategory]: {
        [N in keyof YandexEventArgsMap[C]]: string;
    };
} = {
    tasks: {
        filterSearch: 'TASKS_FILTER_SEARCH',
        filterColor: 'TASKS_FILTER_COLOR',
        filterTags: 'TASKS_FILTER_TAGS',
        filterObjectsOrEstimates: 'TASKS_FILTER_OBJECTS-ESTIMATES',
        filterExecutor: 'TASKS_FILTER_EXECUTOR',
        filterTypes: 'TASKS_FILTER_TYPES',
    },
    eventJournal: {
        tab: 'EVENT_JOURNAL_TAB',
    },
    widgets: {
        tab: 'widget_store_view',
        viewFullDescription: 'widget_view',
        connect: 'widget_connect',
        purchase: 'widget_purchase',
        prolong: 'widget_prolong',
    },
} as const;

export type YandexFlatEvent = {
    [C in YandexEventCategory]: {
        [N in YandexEventName<C>]: {
            category: C;
            name: N;
            externalName: typeof YANDEX_EVENT_NAMES[C][N];
            args: YandexEventArgs<C, N>;
        };
    }[YandexEventName<C>];
}[YandexEventCategory];
